import { rest } from 'utils';

export default {
  getAll: () => rest.get({ url: '/templates?depth=2' }),
};
